var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',[_c('v-app-bar',{attrs:{"app":"","flat":""}},[_c('v-img',{staticClass:"mx-2",attrs:{"src":_vm.appLogo,"max-height":"150","max-width":"150"}})],1),_c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1),_c('SnackBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }